<div class="info-text">
  <p class="title-section">Dúvidas frequentes</p>
  <p class="text-section">Reunimos as principais perguntas e respostas para te ajudar a
    navegar e aproveitar melhor a plataforma.</p>
</div>

<mat-form-field appearance="outline" class="search-field">
  <mat-label>Buscar por dúvida</mat-label>
  <img matPrefix src="../../../../../assets/svg/icons/search.svg" alt="Lupa" class="search-icon" />
  <input
    matInput
    type="text"
    placeholder=" "
    (input)="updateFieldText($event)"
  />
</mat-form-field>

<div *ngFor="let faq of faqsList; let i = index" class="faq-item">
  <div class="faq-question" (click)="toggleExpanded(i)">
    <p class="title-faq" [innerHTML]="highlightText(faq.titulo)"></p>
    <img
      [src]="expandedIndexes.includes(i) ? '../../../../assets/svg/icons/resume.svg' : '../../../assets/svg/icons/expand.svg'"
      alt="Ícone de expansão"
      class="faq-toggle-icon"
    />
  </div>
  <div class="faq-answer" *ngIf="expandedIndexes.includes(i)">
    <div class="markdown-content" [innerHTML]="convertMarkdown(faq.descricao)"></div>
  </div>
</div>
